export default __webpack_public_path__ + "static/media/AdaptiveTheme.58990837.mp4";